/* @flow */
import { GET_ORDERS_SUCCESS, SET_CURRENT_ORDER, UPDATE_ACCOUNT_ORDERS_SUCCESS, SEND_COMMENT_SUCCESS } from '../../configs/constants'
import InitialState from './initialState'
import _ from 'lodash'

const initialState = new InitialState()

export default function commonReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.merge(state)

  switch (action.type) {
    case GET_ORDERS_SUCCESS:
      return state.set('all', action.orders)
    case SET_CURRENT_ORDER:
      sessionStorage.setItem('currentOrder', JSON.stringify(action.order))
      return state.set('current', action.order)
    case UPDATE_ACCOUNT_ORDERS_SUCCESS:
      return state.set('all', action.orders)
    case SEND_COMMENT_SUCCESS:
      let order = _.find(state.all, { id: action.payload.orderId })
      order.comment = action.payload.comment
      return state.set('all', [ ...state.all, order ])
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/order/index.js